import styled from "styled-components";
import { lighten, darken } from "polished";
import styledMap from "styled-map";

import theme from "config/theme";

import Button from "components/Button";

export const Wrapper = styled(Button)`
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  padding: 0;
  border: none;
  z-index: 3;
  background-color: transparent;
  box-shadow: none;
  opacity: 0.4;
  transform: translateY(-50%);
  left: ${props => (props.type === "next" ? "auto" : "5px")};
  right: ${props => (props.type === "next" ? "5px" : "auto")};

  &:hover {
    opacity: 1;
    box-shadow: none;

    background-color: ${styledMap("shade", {
      dark: darken(0.05, theme.color.paper2),
      default: lighten(0.1, theme.color.gray)
    })};
  }

  &:active {
    transform: translateY(-50%) scale(0.9);
  }

  svg {
    transform: ${props =>
      props.type === "next"
        ? "translateX(1px)"
        : "translateX(-1px) rotate(180deg)"};

    color: ${styledMap("shade", {
      dark: theme.color.gray,
      default: "white"
    })};
  }
`;
